<template>
    <v-row justify="center" style="position:relative;">
     
      <div class="videoFrame" style="position: relative;" v-if="playScorm">
        <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on, attrs }" >
          <v-btn
            color="primary"
            v-bind="attrs"
            v-on="on"
            id="ScormFullScreen"
            class="xyz"
            alt="Full Screen" title="Full Screen"
          >
            <i class="fas fa-expand"></i>
          </v-btn>
        </template>
        <v-card>
            <v-spacer></v-spacer>
              <v-btn
              icon
              dark
              @click="dialog = false"
              style="position: absolute;margin-top: 5px;float: right;color: black;background-color: lightgray;top:0;right:0;"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
           <iframe id="myScormIframe" :src="selectedScormForDialog" style="width:100%;height: 120vh; border:0px; verticle-align:top;" scrolling="no"></iframe>
        </v-card>
      </v-dialog>
      <iframe id="myScormIframe" :src="selectedScorm" style="width:100%;height: 400px; border:0px; verticle-align:top;" scrolling="no"></iframe>
      </div>
      <div v-else>
      </div>
    </v-row>
  </template>
  <script>
  import { EventBus } from "@/event-bus.js";

  export default {
    name: "ScormPlayer",
    props: {
        item: {
          type: Object,
          default: null
        },
        courseUserId:{
          type: String,
          default: null
        }
    },
    data() {
      return {
        id: this.$route.params.id,
        dialog: false,
        scormFile: '',
      };
    },
    computed: {
      selectedScorm: function() {
        var slider = this.$store.getters.currentScorm.file.data;
        return this.getScormPath(slider);
      },
      selectedScormForDialog: function() {
        var slider = this.$store.getters.currentScorm.file.data;
        return this.getScormPathForDialog(slider);
      },
      playScorm: function() {
        return this.$store.getters.playScorm;
      },
      userName: function() {
        const user = this.$store.getters.user;
        return user.first_name + " " + user.last_name;
      },
    },
    mounted() {
      this.$store.commit('setPlayScorm', false);  
      //this.getScormPath(this.item);
    },
    methods: {
      getScormPath(item) {
        if(!this.dialog) {
          var newUrl = '';
          if(item.scorm_file_type=='tincan') {
            newUrl = process.env.VUE_APP_SCORM_WRAPPER + '?entrypoint='+item.scorm_file+'&course_user_id='+this.courseUserId+'&user_name=' + this.userName+'&asset_id=' + item.id + '&version=' + item.scorm_version;
          } else {
            newUrl = process.env.VUE_APP_SCORM_WRAPPER + '?entrypoint='+item.scorm_file+'&course_user_id='+this.courseUserId+'&user_name=' + this.userName+'&asset_id=' + item.id + '&version=' + item.scorm_version;
          }
        } else {
          newUrl = "";
        }
        return newUrl;
      },
      getScormPathForDialog(item) {
        var newUrl = '';
        if(this.dialog) {
          if(item.scorm_file_type=='tincan') {
            newUrl = process.env.VUE_APP_SCORM_WRAPPER + '?entrypoint='+item.scorm_file+'&course_user_id='+this.courseUserId+'&user_name=' + this.userName+'&asset_id=' + item.id + '&version=' + item.scorm_version;
          } else {
            newUrl = process.env.VUE_APP_SCORM_WRAPPER + '?entrypoint='+item.scorm_file+'&course_user_id='+this.courseUserId+'&user_name=' + this.userName+'&asset_id=' + item.id + '&version=' + item.scorm_version;
          }
        } else {
          newUrl = "";
        }
        return newUrl;
      },
    },
     beforeDestroy() { // Vue 2
       EventBus.$off("SCORM_COMPLETED");
    },
  };
  </script>
  <style>
  .xyz:hover {
    color: #fff !important;
  }
  .xyz {
    position:absolute;
    bottom: -35px;
    right: 0px;
  }
  @media (min-width: 2801px) and (max-width: 3500px) {
  .videoFrame {
      width:70%;
      text-align:center;
    }
  
  }
  
  @media (min-width: 2301px) and (max-width: 2800px) {
    .videoFrame {
      width:70%;
      text-align:center;
    }
  }
  
  @media (min-width: 1801px) and (max-width: 2300px) {
    .videoFrame {
      width:100%;
      text-align:center;
    }
  }
  
  @media (min-width: 1601px) and (max-width: 1800px) {
    .videoFrame {
      width:100%;
      text-align:center;
    }
  }
  
  @media (min-width: 1401px) and (max-width: 1600px) {
    .videoFrame {
      width:100%;
      text-align:center;
    }
  }
  
  @media (min-width: 1201px) and (max-width: 1400px) {
    .videoFrame {
      width:100%;
      text-align:center;
    }
  }
  
  @media (min-width: 961px) and (max-width: 1200px) {
    .videoFrame {
      width:100%;
      text-align:center;
    }
  }
  
  @media (min-width: 801px) and (max-width: 960px) {
    .videoFrame {
      width:100%;
      text-align:center;
    }
  }
  
  @media (min-width: 601px) and (max-width: 800px) {
    .videoFrame {
      width:100%;
      text-align:center;
    }
  }
  
  @media (min-width: 600px) and (max-width: 800px) {
    .videoFrame {
      width:100%;
      text-align:center;
    }
  }
  
  
  @media (min-width: 376px) and (max-width: 667px) {
  .videoFrame {
      width:100%;
      text-align:center;
    }
  
  }
  
  </style>
  